var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNj(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 90,
    viewBox: "0 0 48 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3552 14.7744L25.2295 1L22.563 2.08536L13.5282 15.4568L15.1545 19.4924L11.4201 23.0461L11.902 29.9125L14.7931 30.2137L15.4557 35.3936L25.153 44.6693L14.7931 50.572L12.3838 54.8485L5.27647 57.5589L1 63.9435L1.18068 68.3405L2.44562 69.7258L5.63791 71.2918L4.49357 72.6169L9.43264 75.4478L12.8659 80.0857L15.8775 78.5196L19.9131 81.2903L17.5038 87.7954L18.6482 89L23.0451 86.1089L28.5865 77.2548L26.8397 77.315L26.2976 75.6887L30.8753 75.0262L34.7903 70.3883L33.0436 67.7381L40.2112 61.0524L39.3077 58.8238L44.6082 42.6817L45.3912 37.6222L41.5965 34.189L38.1031 34.0083L37.3803 30.7557L39.8498 27.3225L42.9819 27.0816L47.3552 14.7744Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNj);
export default __webpack_public_path__ + "static/media/NJ.b7567295de762ebde156c211f0162bdb.svg";
export { ForwardRef as ReactComponent };